import htmlLogo from './assets/tech_logo/html.png';
import cssLogo from './assets/tech_logo/css.png';
import sassLogo from './assets/tech_logo/sass.png';
import javascriptLogo from './assets/tech_logo/javascript.png';
import reactjsLogo from './assets/tech_logo/reactjs.png';
import angularLogo from './assets/tech_logo/angular.png';
import reduxLogo from './assets/tech_logo/redux.png';
import nextjsLogo from './assets/tech_logo/nextjs.png';
import tailwindcssLogo from './assets/tech_logo/tailwindcss.png';
import gsapLogo from './assets/tech_logo/gsap.png';
import materialuiLogo from './assets/tech_logo/materialui.png';
import bootstrapLogo from './assets/tech_logo/bootstrap.png';
import springbootLogo from './assets/tech_logo/springboot.png';
import nodejsLogo from './assets/tech_logo/nodejs.png';
import expressjsLogo from './assets/tech_logo/express.png';
import mysqlLogo from './assets/tech_logo/mysql.png';
import mongodbLogo from './assets/tech_logo/mongodb.png';
import firebaseLogo from './assets/tech_logo/firebase.png';
import cLogo from './assets/tech_logo/c.png';
import cppLogo from './assets/tech_logo/cpp.png';
import javaLogo from './assets/tech_logo/java.png';
import pythonLogo from './assets/tech_logo/python.png';
import typescriptLogo from './assets/tech_logo/typescript.png';
import gitLogo from './assets/tech_logo/git.png';
import githubLogo from './assets/tech_logo/github.png';
import vscodeLogo from './assets/tech_logo/vscode.png';
import postmanLogo from './assets/tech_logo/postman.png';
import mcLogo from './assets/tech_logo/mc.png';
import figmaLogo from './assets/tech_logo/figma.png';
import netlifyLogo from './assets/tech_logo/netlify.png';
import vercelLogo from './assets/tech_logo/vercel.png';
import postgreLogo from './assets/tech_logo/postgre.png';
import csharpLogo from './assets/tech_logo/csharp.png';
import cursorLogo from './assets/tech_logo/cursor.png';
import dockerLogo from './assets/tech_logo/docker.png';
import awsLogo from './assets/tech_logo/aws.png';
import kubernetesLogo from './assets/tech_logo/kubernetes.png';
import jiraLogo from './assets/tech_logo/jira.png';
import aspnetLogo from './assets/tech_logo/aspnet.png';
import aspnetcoreLogo from './assets/tech_logo/aspnetcore.png';
import powerBiLogo from './assets/tech_logo/powerBi.png';
import openaiLogo from './assets/tech_logo/OpenAI.png';
import langchainLogo from './assets/tech_logo/langchain.png';
import aiLogo from './assets/tech_logo/ai.jpeg';

export const SkillsInfo = [
  {
    title: 'Generative AI',
    skills: [
      { name: 'OpenAI API', logo: openaiLogo, percentage: 90 },
      { name: 'LangChain', logo: langchainLogo, percentage: 85 },
      { name: 'Agentic AI', logo: aiLogo, percentage: 80 },
      { name: 'Prompt Engineering', logo: aiLogo, percentage: 95 },
      { name: 'LLM Orchestration', logo: aiLogo, percentage: 88 },
    ],
  },
  {
    title: 'Frontend',
    skills: [
      { name: 'HTML', logo: htmlLogo, percentage: 95 },
      { name: 'CSS', logo: cssLogo, percentage: 90 },
      { name: 'Sass', logo: sassLogo, percentage: 85 }, // Restored sassLogo
      { name: 'JavaScript', logo: javascriptLogo, percentage: 85 },
      { name: 'React JS', logo: reactjsLogo, percentage: 88 },
      { name: 'Redux', logo: reduxLogo, percentage: 80 },
      { name: 'Tailwind CSS', logo: tailwindcssLogo, percentage: 82 },
      { name: 'GSAP', logo: gsapLogo, percentage: 75 }, // Restored gsapLogo
      { name: 'Material UI', logo: materialuiLogo, percentage: 75 },
      { name: 'Bootstrap', logo: bootstrapLogo, percentage: 70 },
      { name: 'Angular', logo: angularLogo, percentage: 70 },
      { name: 'Next JS', logo: nextjsLogo, percentage: 70 },
      { name: 'TypeScript', logo: typescriptLogo, percentage: 70 },
    ],
  },
  {
    title: 'Backend',
    skills: [
      { name: 'Node JS', logo: nodejsLogo, percentage: 78 },
      { name: 'Express JS', logo: expressjsLogo, percentage: 75 },
      { name: 'MySQL', logo: mysqlLogo, percentage: 70 },
      { name: 'MongoDB', logo: mongodbLogo, percentage: 65 },
      { name: 'Firebase', logo: firebaseLogo, percentage: 60 },
      { name: 'PostgreSQL', logo: postgreLogo, percentage: 68 },
      { name: 'Spring Boot', logo: springbootLogo, percentage: 70 },
    ],
  },
  {
    title: 'Languages',
    skills: [
      { name: 'C', logo: cLogo, percentage: 60 },
      { name: 'C++', logo: cppLogo, percentage: 65 },
      { name: 'Java', logo: javaLogo, percentage: 70 },
      { name: 'Python', logo: pythonLogo, percentage: 80 },
      { name: 'C-Sharp', logo: csharpLogo, percentage: 55 },
      { name: 'Asp.net', logo: aspnetLogo, percentage: 70 },
      { name: 'Asp.net Core', logo: aspnetcoreLogo, percentage: 70 },
    ],
  },
  {
    title: 'Tools',
    skills: [
      { name: 'Git', logo: gitLogo, percentage: 90 },
      { name: 'GitHub', logo: githubLogo, percentage: 85 },
      { name: 'VS Code', logo: vscodeLogo, percentage: 95 },
      { name: 'Figma', logo: figmaLogo, percentage: 80 }, // Restored figmaLogo
      { name: 'Postman', logo: postmanLogo, percentage: 80 },
      { name: 'Compass', logo: mcLogo, percentage: 70 },
      { name: 'Vercel', logo: vercelLogo, percentage: 75 },
      { name: 'Netlify', logo: netlifyLogo, percentage: 72 },
      { name: 'Cursor', logo: cursorLogo, percentage: 80 },
      { name: 'Docker', logo: dockerLogo, percentage: 70 },
      { name: 'AWS', logo: awsLogo, percentage: 70 },
      { name: 'Kubernetes', logo: kubernetesLogo, percentage: 70 },
      { name: 'Jira', logo: jiraLogo, percentage: 70 },
      { name: 'PowerBi', logo: powerBiLogo, percentage: 70 }
    ],
  },
];